import {Component, OnInit} from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
    selector: 'eci-commercial-invoice-form',
    templateUrl: './commercial-invoice-form.component.html',
    styleUrls: ['./commercial-invoice-form.component.scss']
})
export class CommercialInvoiceFormComponent extends InvoiceTemplateBase implements OnInit {

    ngOnInit(): void {
        this.model = {
            ...this.template,
            ...this.invoice,
            customerCompany: {
                ...this.template.customerCompany,
                ...this.invoice.customerCompany
            }
        };
    }

}
